import { CommonScriptComponent } from './../common-script/common-script.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-custom-software-dev',
  templateUrl: './custom-software-dev.component.html',
  styleUrls: ['./custom-software-dev.component.css']
})
export class CustomSoftwareDevComponent implements OnInit {

  constructor(private commonScriptComponent:CommonScriptComponent) { }

  ngOnInit() {
    this.commonScriptComponent.onLoad();
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/custom-software-dev/custom-software-dev.component.ts